import { FreelancerListItem, AtributoMedia } from "@/types/freelancer";

/** Iniciais para avatar fallback. */
export function getInitials(nome: string | undefined | null): string {
  if (!nome) return "?";
  const parts = nome.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Localização compacta "City/State" ou fallback para `cidade` legado. */
export function formatLocation(f: FreelancerListItem): string | null {
  if (f.city && f.state) return `${f.city}/${f.state}`;
  if (f.city) return f.city;
  if (f.state) return f.state;
  return f.cidade ?? null;
}

/** Áreas que estão no filtro primeiro, mantendo a ordem original dentro de cada grupo. */
export function prioritizeAreas(areas: string[], filteredAreas: string[]): string[] {
  if (filteredAreas.length === 0) return areas;
  const matching = areas.filter((area) => filteredAreas.includes(area));
  const others = areas.filter((area) => !filteredAreas.includes(area));
  return [...matching, ...others];
}

/** Top N atributos com maior média (e que têm pelo menos 1 avaliação). */
export function topAttributes(
  atributos: AtributoMedia[] | undefined,
  count: number,
): AtributoMedia[] {
  if (!atributos || atributos.length === 0) return [];
  return [...atributos]
    .filter((a) => a.total > 0 && typeof a.media === "number")
    .sort((a, b) => b.media - a.media)
    .slice(0, count);
}

/** Resumo curtinho do tipo de atuação + interesse em vaga fixa. */
export function buildAvailabilityChip(f: FreelancerListItem): string | null {
  const tipo =
    f.tipo_atuacao === "Minha principal ou única fonte de renda"
      ? "Renda principal"
      : f.tipo_atuacao === "Um complemento para minha renda"
        ? "Renda extra"
        : null;
  const vagaFixa = f.interesse_vaga_fixa === true ? "Vaga fixa" : null;
  const mudar = f.interesse_em_mudar_emprego === true ? "Quer mudar de emprego" : null;
  return [mudar, tipo, vagaFixa].filter(Boolean).join(" · ") || null;
}

/** Ficha do freelancer mantendo a vaga e a página da lista para o Voltar. */
export function buildFichaUrl(freelancerId: string, vagaId: string | undefined, currentSearch: string): string {
  const params = new URLSearchParams(currentSearch);
  const url = new URL(`/freelancers/${freelancerId}`, window.location.origin);
  if (vagaId) {
    url.searchParams.set("returnTo", "selection");
    url.searchParams.set("vaga", vagaId);
  }
  const page = params.get("page");
  if (page) url.searchParams.set("page", page);
  return url.pathname + url.search;
}
